import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production) {
	const lorenz = document.cookie
		.split('; ')
		.find((row) => row.startsWith('lorenz='))
		?.split('=')[1];

	// If the "lorenz cookie" has the value true, the console outputs are not deactivated!
	// document.cookie = "lorenz=true"
	// document.cookie = "lorenz=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";

	if (!lorenz || lorenz !== 'true') {
		(() => {
			const noop = () => {};
			window.console.log = noop;
			window.console.warn = noop;
			window.console.error = noop;
			window.console.info = noop;
		})();
	}
}

bootstrapApplication(AppComponent, appConfig)
	.catch((err) => console.error(err));
